import Collection from "../../../data-structures/collection";
import AIChatMessage from "./chat-message";
import {AiChatMessageType, AiChatParticipant} from "../@const";
import AiChatMessage_TokenUsage from "./token-usage/token-usage";


export default class AIChatMessage_Collection extends Collection<AIChatMessage> {

    constructor(models: AIChatMessage[]) {
        super(models);
    }


    static initFromJSON(data: JSONArray) {

        const collection = new AIChatMessage_Collection([])

        let queryMessageMomentCreated: Moment | null = null

        _.map(data, (item: JSONObject) => {

            const model = new AIChatMessage(item)

            // Skip Backend -> AI query messages
            if (model.isQuery) {
                collection.add(model)
                queryMessageMomentCreated = model.momentCreated
                return
            }

            // Skip Backend -> User answer messages. There are no tokens here!!!!s
            // if (model.type === AiChatMessageType.ANSWER && model.sender !== AiChatParticipant.AI) {
            //     collection.add(model)
            // }

            // Skip AI -> Backend answer messages. It's for show tokens in messages
            if (model.isAnswer) {

                if (!!queryMessageMomentCreated) {
                    model.answerTime = model.momentCreated.diff(queryMessageMomentCreated, 'millisecond')
                }

                collection.add(model)

                queryMessageMomentCreated = null
                return
            }
            collection.add(model)
            return

            // if (model.isError) {
            //     collection.add(model)
            // }
            //
            // // Return all TOOLS_CALL_RESPONSE and TOOLS_CALL_REQUEST messages
            // if (model.isToolsCallsResponse || model.isToolsCallsRequest || model.isToolSelection || model.isCompaction || model) {
            //     collection.add(model)
            // }

        })

        return collection
    }

    // Nado sortirovat na Backend
    sortByMomentCreated() {
        this.models = _.sortBy(
            this.models,
            (model) => {
                return model.momentCreated.unix()
            },
            ["desc"]
        )

    }

    get summaryTokens(): AiChatMessage_TokenUsage {
        return _.reduce(this.models, (acc: any, model)=> {

            if (!!model.tokens) {
                acc['totalTokens'] += model.tokens?.totalTokens
                acc['inputTokens'] += model.tokens?.inputTokens
                acc['cachedTokens'] += model.tokens?.cachedTokens
                acc['outputTokens'] += model.tokens?.outputTokens
                acc['cost'] += model.cost
            }

            return acc

        }, {
            totalTokens: 0,
            inputTokens: 0,
            cachedTokens: 0,
            outputTokens: 0,
            cost: 0,
        })
    }

}
